export default __webpack_public_path__ + "static/media/char_body_prem_014.0f58ef33.png";